export enum XpressUserRoleEnum {
    None = 0,
    Admin = 1,
    Merchant = 2,
    Rider = 3,
    User = 4,
	Operator = 5,
	RegionAdmin = 7,
	System = 8,
    CommandCenterAdmin = 9,
    TourOperator = 10
}
